import React from 'react';

import TemplateSelection from '@components/TemplateSelection';
import { NextPageWithAuth } from 'global';
// import Navbar from './Navbar';
import styles from './playbook.module.scss';
import Head from 'next/head';
import { useAuth } from '@utils/useAuth';
import dynamic from 'next/dynamic';

const Navbar = dynamic(() => import('./Navbar'), { ssr: false });

const PlaybookPage: NextPageWithAuth = () => {
  const { isLoggedIn } = useAuth();

  return (
    <>
      <Head>
        <title>Playbook - Popupsmart</title>
        <meta name="robots" content="nofollow, noindex" />
      </Head>
      <div className={styles.playbookWrapper}>
        <Navbar isLoggedIn={isLoggedIn} />
        <TemplateSelection isShowcase={true} />
      </div>
    </>
  );
};

PlaybookPage.isPublicRoute = true;
export default PlaybookPage;
